/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ContentWrapper from './ContentWrapper';


@inject('navigationStore')
@observer
class NavigationAwarePageContent extends Component {
  render() {
    const { navigationStore, children } = this.props;
    return (
      <ContentWrapper mobileNavOpened={navigationStore.isMobileNavOpen}>
        {children}
      </ContentWrapper>
    );
  }
}

export default NavigationAwarePageContent;



// WEBPACK FOOTER //
// ./src/blocks/NavigationAwarePageContent/index.jsx